import { render } from "./CreateClientPage.vue?vue&type=template&id=64baa2ea"
import script from "./CreateClientPage.vue?vue&type=script&lang=js"
export * from "./CreateClientPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__